"use client";

import BaseIndicatorConfig from "../common/BaseIndicatorConfig";

interface BollingerBandsConfigProps {
  indicator: Parameters<typeof BaseIndicatorConfig>[0]["indicator"];
  onBack: () => void;
  onApply: (indicator: any) => void;
  isEditing?: boolean;
}

export default function BollingerBandsConfig({
  indicator,
  onBack,
  onApply,
  isEditing,
}: BollingerBandsConfigProps) {
  return (
    <BaseIndicatorConfig
      indicator={indicator}
      onBack={onBack}
      onApply={onApply}
      isEditing={isEditing}
      defaultExpandedStyle="upper"
    />
  );
}
